"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStyles = void 0;
var styles_1 = require("@material-ui/core/styles");
exports.useStyles = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: {
            minHeight: '100vh',
            display: 'relative',
            zIndex: 0,
        },
        // always visible and full screen height
        menu: function (_a) {
            var menuWidth = _a.menuWidth;
            return ({
                position: 'fixed',
                left: 0,
                top: 0,
                zIndex: 2,
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                maxHeight: '100vh',
                overflowY: 'hidden',
                width: menuWidth,
                background: "linear-gradient(180deg, ".concat(theme.palette.primary.light, " 0%, ").concat(theme.palette.primary.dark, " 100%)"),
                color: theme.palette.primary.contrastText,
                boxShadow: theme.shadows[2],
                '& :after': {
                    content: ' ',
                },
            });
        },
        // appLogo
        appLogo: {
            width: '100%',
            padding: 12,
        },
        // menu options at the start
        topMenu: {
            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
        },
        // secondary menu options at the end
        bottomMenu: {
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: theme.spacing(2),
        },
        // can be toggled between open/closed
        drawer: function (_a) {
            var drawerWidth = _a.drawerWidth, menuWidth = _a.menuWidth, slideoutOptions = _a.slideoutOptions;
            var _b = theme.custom.slideout, bgColor = _b.bgColor, contrastText = _b.contrastText;
            return {
                // allow for NO DRAWER when options are omitted
                display: slideoutOptions ? undefined : 'hidden',
                position: 'fixed',
                top: 0,
                left: menuWidth,
                zIndex: 1,
                minHeight: '100vh',
                maxHeight: '100vh',
                overflowY: 'hidden',
                whiteSpace: 'nowrap',
                width: drawerWidth,
                backgroundColor: bgColor,
                color: contrastText,
            };
        },
        denseList: {
            padding: 0,
        },
        // overrides for icon button
        toggleButton: {
            backgroundColor: theme.custom.slideoutToggle.bgColor,
            color: theme.custom.slideoutToggle.contrastText,
            boxShadow: theme.shadows[1],
            padding: '0',
            '&:hover': {
                backgroundColor: theme.custom.slideoutToggle.bgColor,
            },
        },
        // using this for icon button position
        floatingButtonContainer: function (_a) {
            var drawerOpen = _a.drawerOpen, drawerWidth = _a.drawerWidth, menuWidth = _a.menuWidth;
            return ({
                position: 'fixed',
                top: theme.spacing(2),
                // closed drawer needs to have less left positioning to be centered
                left: drawerOpen ? drawerWidth + menuWidth - 12 : menuWidth - 4,
                zIndex: 3,
                transitionProperty: 'left',
                transitionDuration: "".concat(theme.transitions.duration.standard, "ms"),
                transition: theme.transitions.easing.easeInOut,
            });
        },
        // the real content on the page belongs here
        // resizes with menu and drawer widths and still scroll freely
        content: function (_a) {
            var drawerOpen = _a.drawerOpen, drawerWidth = _a.drawerWidth, menuWidth = _a.menuWidth, slideoutOptions = _a.slideoutOptions;
            var gutter = theme.spacing(4);
            var maxPadding = drawerWidth + menuWidth;
            var minPadding = menuWidth + theme.spacing(1);
            return {
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                height: '100vh',
                overflow: 'auto',
                padding: 0,
                margin: 0,
                paddingRight: gutter,
                paddingLeft: gutter,
                // shift content over when drawer is open AND options are defined
                marginLeft: drawerOpen && slideoutOptions ? maxPadding : minPadding,
                backgroundColor: theme.palette.background.default,
                transitionProperty: 'margin',
                transitionDuration: "".concat(theme.transitions.duration.standard, "ms"),
                transition: theme.transitions.easing.easeInOut,
                zIndex: 2,
            };
        },
        sectionHeader: {
            color: theme.custom.slideout.mutedText,
            textTransform: 'uppercase',
        },
        sectionListItem: {
            margin: "".concat(theme.spacing(1), "px"),
            width: "calc(100% - ".concat(theme.spacing(2), "px)"),
            '&.Mui-selected': {
                color: theme.palette.secondary.main,
                backgroundColor: 'rgba(255,255,255,0.25)',
                fontWeight: 500,
            },
            '&.Mui-selected .MuiListItemText-root span': {
                fontWeight: 700,
            },
        },
    });
});
